import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { Covid19ClosureComponent } from './closure/covid-19-closure.component';
import { Covid19Router } from './covid-19.router';
import {Covid19ReopeningComponent} from "OpsCenter/ops-support/covid-19/reopening/covid-19-reopening.component";

/** @constant {angular.module} */
const covid19Module = angular
  .module('ec.opsCenter.ops-support.covid-19', [])
  .config(Covid19Router)
  .directive('appCovid19Closure', downgradeComponent({ component: Covid19ClosureComponent }) as angular.IDirectiveFactory)
  .directive('appCovid19Reopening', downgradeComponent({ component: Covid19ReopeningComponent }) as angular.IDirectiveFactory).name;

export default covid19Module;



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/covid-19.module.ajs.ts